module.exports = __webpack_public_path__ + "img/mo.ebf1ee3a.svg";